import { THEMES } from "../../core/consts";
import { commonColors as common } from "./common";
import { SemanticBaseColors, ThemeColors } from "./types";
import { generateForegroundColorObject } from "./utils/contrast";

const base: SemanticBaseColors = {
  light: {
    divider: {
      ...common.gray,
      DEFAULT: common.gray["200"],
    },
    focus: {
      ...common.blue,
      DEFAULT: common.blue[500],
    },
    structure: {
      ...common.beige,
      DEFAULT: common.beige[500],
    },
  },
};

const sharedThemeColors: Pick<
  ThemeColors,
  "success" | "warning" | "danger" | "default"
> = {
  danger: {
    ...common.red,
    dark: common.red[800],
    DEFAULT: common.red[700],
    light: common.red[100],
    ...generateForegroundColorObject({
      dark: common.red[800],
      DEFAULT: common.red[700],
      light: common.red[100],
    }),
  },
  default: {
    ...common.gray,
    DEFAULT: common.gray["700"],
    ...generateForegroundColorObject({
      DEFAULT: common.gray["700"],
    }),
    disabled: common.gray["600"],
  },
  success: {
    ...common.green,
    dark: common.green[800],
    DEFAULT: common.green[600],
    light: common.green[50],
    ...generateForegroundColorObject({
      dark: common.green[800],
      DEFAULT: common.green[600],
      light: common.green[50],
    }),
  },
  warning: {
    ...common.orange,
    dark: common.orange[700],
    DEFAULT: common.orange[400],
    light: common.orange[50],
    ...generateForegroundColorObject({
      dark: common.orange[700],
      DEFAULT: common.orange[400],
      light: common.orange[50],
    }),
  },
};

const themeRecare: DeepPartial<ThemeColors> = {
  ...base.light,
  ...sharedThemeColors,
  accent: {
    ...common.purple,
    dark: common.purple[600],
    DEFAULT: common.purple[300],
    light: common.purple[200],
    ...generateForegroundColorObject({
      dark: common.purple[600],
      DEFAULT: common.purple[300],
      light: common.purple[200],
    }),
  },
  primary: {
    ...common.blue,
    dark: common.blue[800],
    DEFAULT: common.blue[500],
    light: common.blue[50],
    ...generateForegroundColorObject({
      dark: common.blue[800],
      DEFAULT: common.blue[500],
      light: common.blue[50],
    }),
  },
  secondary: {
    ...common.yellow,
    dark: common.yellow[300],
    DEFAULT: common.yellow[200],
    light: common.yellow[100],
    ...generateForegroundColorObject({
      dark: common.yellow[300],
      DEFAULT: common.yellow[200],
      light: common.yellow[100],
    }),
  },
};

const themeProviderSearchBavaria: DeepPartial<ThemeColors> = {
  ...base.light,
  ...sharedThemeColors,
  accent: {
    ...common.providerSearchAccent,
    dark: common.providerSearchAccent[900],
    light: common.providerSearchAccent[50],
    ...generateForegroundColorObject({
      dark: common.providerSearchAccent[900],
      light: common.providerSearchAccent[50],
    }),
  },
  primary: {
    ...common.magenta,
    dark: common.magenta[800],
    DEFAULT: common.magenta[500],
    light: common.magenta[300],
    ...generateForegroundColorObject({
      dark: common.magenta[800],
      DEFAULT: common.magenta[500],
      light: common.magenta[300],
    }),
  },
  ...sharedThemeColors,
};

const themeProviderSearchWeserEms: DeepPartial<ThemeColors> = {
  ...themeProviderSearchBavaria,
  primary: {
    ...common.steelBlue,
    dark: common.steelBlue[800],
    DEFAULT: common.steelBlue[600],
    light: common.steelBlue[200],
    ...generateForegroundColorObject({
      dark: common.steelBlue[800],
      DEFAULT: common.steelBlue[600],
      light: common.steelBlue[200],
    }),
  },
};

// to be deprecated
const themeB2C: DeepPartial<ThemeColors> = {
  ...base.light,
  ...sharedThemeColors,
  primary: {
    ...common.steelBlue,
    dark: common.steelBlue[800],
    DEFAULT: common.steelBlue[600],
    light: common.steelBlue[200],
    ...generateForegroundColorObject({
      dark: common.steelBlue[800],
      DEFAULT: common.steelBlue[600],
      light: common.steelBlue[200],
    }),
  },
  ...sharedThemeColors,
};

export const semanticColors = {
  [THEMES.B2C]: themeB2C,
  [THEMES.PROVIDER_SEARCH_BAVARIA]: themeProviderSearchBavaria,
  [THEMES.PROVIDER_SEARCH_WESER_EMS]: themeProviderSearchWeserEms,
  [THEMES.RECARE]: themeRecare,
};
